import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from 'components/icons/icon';

export default class ButtonIcon extends React.Component {
  constructor(props){
    super();
  }

  render() {
    const { className, children, description, disabled, iconType, iconSize, iconClasses, onClick } = this.props;
    const type = this.props.type ? this.props.type : 'button';
    const btnClasses = classNames(
      'btnIcon',
      {
        [`${className}`]: className
      }
    )

    if (!description) {
      console.warn('WARNING: Please add a description attribute to your ButtonIcon for accessibility purposes');
    }
    return (
      <button
        className={btnClasses}
        disabled={disabled}
        onClick={onClick}
        type={type}
        ref={el => { this.btnRef = el; }}
      >
        <span className="isVisuallyHidden">{description}</span>
        <Icon
          className={iconClasses}
          iconType={iconType}
          iconSize={iconSize}
        />
        {children}
      </button>
    );
  }
}

ButtonIcon.propTypes = {
  type: PropTypes.string,
  descripton: PropTypes.string,
  disabled: PropTypes.bool,
  iconType: PropTypes.string,
  iconSize: PropTypes.string,
  iconClasses: PropTypes.string,
  onClick: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/client/components/button/button-icon.jsx